import * as returnOrders from './returnOrders';
import * as returnClaim from './returnClaim';

export const Actions = {
  ...returnOrders,
  ...returnClaim,
};
